"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addWrapperToChildren = exports.formatDangerouslySetInnerHTML = void 0;
var _react = _interopRequireDefault(require("react"));
var _shortid = _interopRequireDefault(require("shortid"));
var _get = _interopRequireDefault(require("lodash/get"));
var _htmlCheck = _interopRequireDefault(require("@berlitz/max-utils/lib/htmlCheck"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var formatDangerouslySetInnerHTML = function formatDangerouslySetInnerHTML(dangerouslySetInnerHTML) {
  if (!dangerouslySetInnerHTML) return {
    __html: null
  };
  var DOMWrapper = document.createElement('div');
  DOMWrapper.innerHTML = dangerouslySetInnerHTML.__html; // add p tag to stray strings

  if (!_htmlCheck.default.test(DOMWrapper.innerHTML)) {
    DOMWrapper.innerHTML = "<p>".concat(DOMWrapper.innerHTML, "</p>");
  } // format iframe

  var iFramesList = Array.prototype.slice.call(DOMWrapper.querySelectorAll('iframe'));
  iFramesList.forEach(function (element) {
    var videoWrapper = document.createElement('div');
    videoWrapper.classList.add('video-16x9');
    videoWrapper.innerHTML = element.outerHTML;
    element.parentNode.replaceChild(videoWrapper, element);
  }); // format audio

  var audioList = Array.prototype.slice.call(DOMWrapper.querySelectorAll('audio'));
  audioList.forEach(function (element) {
    var newAudioButton = document.createElement('button');
    newAudioButton.classList.add('rich-text-audio-button');
    newAudioButton.innerHTML = '<span class="play-icon">&#9658;</span><span class="pause-icon">&#9616;&#9616;</span>';
    if (element !== null && element !== void 0 && element.parentNode && newAudioButton) {
      var _element$children, _element$children$;

      // either an <audio src=""/> or an <audio><source src=""/></audio>
      var audioSrc = element.getAttribute('src') || (element === null || element === void 0 ? void 0 : (_element$children = element.children) === null || _element$children === void 0 ? void 0 : (_element$children$ = _element$children[0]) === null || _element$children$ === void 0 ? void 0 : _element$children$.src);
      newAudioButton.setAttribute('data-audio-src', audioSrc);
      element === null || element === void 0 ? void 0 : element.parentNode.replaceChild(newAudioButton, element);
    }
  });
  return {
    __html: DOMWrapper.innerHTML
  };
};
exports.formatDangerouslySetInnerHTML = formatDangerouslySetInnerHTML;
var addWrapperToChildren = function addWrapperToChildren(children) {
  if (!Array.isArray(children)) return children;
  return children.map(function (element) {
    switch (element.type) {
      case 'iframe':
        {
          var iFrameSrc = (0, _get.default)(element, 'props.src', '');
          if (!iFrameSrc.includes('youtube.com')) {
            return /*#__PURE__*/_react.default.cloneElement(element, element.props);
          }
          return /*#__PURE__*/_react.default.createElement("div", {
            key: _shortid.default.generate(),
            className: "video-16x9"
          }, /*#__PURE__*/_react.default.cloneElement(element, element.props));
        }
      default:
        return /*#__PURE__*/_react.default.cloneElement(element, _objectSpread(_objectSpread({}, element.props), {}, {
          key: _shortid.default.generate()
        }));
    }
  });
};
exports.addWrapperToChildren = addWrapperToChildren;